export const SESSION_KEY_FLUXMED_CARD_HIGHLIGHT = "crm.setup.fluxmedCardHighlight.v1";

export const MANUAL_WABA_LOOKUP_MIN_LENGTH = 13;
export const MANUAL_WABA_LOOKUP_DEBOUNCE_MS = 3000;
